$( document ).ready(function() {
  $('.single-slider .slide-list').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    arrows: true,
    slidesToScroll: 1,
    adaptiveHeight: true
  });

  $('.product-slider .product-list').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
})

$('.Product__Wrapper .Product__SlideshowNavScroller').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
   {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
  ]
})



$('.review-slider .review-list').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1
})

$(document).on("click",".bottomLine",function() {
    $('a[href="#tab-review"]').trigger('click');
    $('html, body').animate({
        scrollTop: $('#tab-review').offset().top
    }, 800); 
});

// $(function(){
//   var $modal = $('.embed-container');
//   var HIDE_CLASS = 'is-hide';
  
//   $('#center-img-main').on('click',function(){
//     $modal.removeClass(HIDE_CLASS);
//   });
  
//   $('.js-modal-close').on('click',function(){
//     $modal.addClass(HIDE_CLASS);
//   });
// });


});


$(".select_tabs").click(function() {
  $(this).toggleClass("open");
  });
  $(".select_tabs li").click(function() {
  
    var selected_value = $(this).html();
    var first_li = $(".select_tabs li:first-child").html();
  
    $(".select_tabs li:first-child").html(selected_value);
    $(this).html(first_li);
  
  });
  
  $(document).mouseup(function(event) {
    var target = event.target;
    var select = $(".select_tabs");
    if (!select.is(target) && select.has(target).length === 0) {
      select.removeClass("open");
    }

});



// tabbed content
// http://www.entheosweb.com/tutorials/css/tabs.asp
$(".tab-container .tab_content").hide();
// $(".tab-container .tab_content:first").show();
$('.tab-container').each(function(k,v){
  $(v).find('.tab_content:first').show();
});


/* if in tab mode */
$("ul.tabs li").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var activeTab = $(this).attr("rel");
  $(parent).find("#"+activeTab).fadeIn();

  $(parent).find("ul.tabs li").removeClass("active");
  $(this).addClass("active");

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");

  $('.product-list').slick('refresh');
});

/* if in drawer mode */
$(".tab_drawer_heading").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var d_activeTab = $(this).attr("rel");
  $(parent).find("#"+d_activeTab).fadeIn();

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(this).addClass("d_active");

  $(parent).find("ul.tabs li").removeClass("active");
  $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");

  $('.product-list').slick('refresh');
});